import { IRoomEditorDrawingState } from "./FloorplanEditor";

export interface IMultiSelectCanvasControlsProps {
    drawingState: IRoomEditorDrawingState;
    selectedObjects?: Record<string, number[]>;
}

const MultiSelectCanvasControls = (props: IMultiSelectCanvasControlsProps) => {
    const { drawingState, selectedObjects } = props;
    const { desks, doors, floorplanRectangles, roomRectangles, floorplanShapes, text } = drawingState;

    return null;

    // if (selectedObjects !== undefined) {

    //     let minX = Number.MAX_VALUE;
    //     let minY = Number.MAX_VALUE;
    //     let maxX = Number.MIN_VALUE;
    //     let maxY = Number.MIN_VALUE;
        
    //     // Get the x,y min and max for desks and doors, desks are rotated around their center
    //     if (selectedObjects.desks) {
    //         selectedObjects.desks.forEach(idx => {
    //             const desk = desks[idx];
    //             const truex = desk.x - 10, truey = desk.y - 12.5;
    //             if (desk.x < minX) minX = desk.x;
    //             if (desk.y < minY) minY = desk.y;
    //             if (desk.x + 20 > maxX) maxX = desk.x + 20;
    //             if (desk.y + 20 > maxY) maxY = desk.y + 20;
    //         });
    //     }
    //     if (selectedObjects.doors) {
    //         selectedObjects.doors.forEach(idx => {
    //             const door = doors[idx];
    //             if (door.x < minX) minX = door.x;
    //             if (door.y < minY) minY = door.y;
    //             if (door.x + 20 > maxX) maxX = door.x + 20;
    //             if (door.y + 20 > maxY) maxY = door.y + 20;
    //         });
    //     }
    
    //     // Get the x,y min and max for floorplanRectangles and roomRec
    
    //     // if (selectedDeskIdx !== undefined) {
    //     //     const selectedDesk = desks[selectedDeskIdx];
    //     //     if (selectedDesk) {
    //     //         return (
    //     //             <svg id="deskControlHandles" x={desks[selectedDeskIdx].x+10} y={desks[selectedDeskIdx].y+12.5} overflow="visible">
    //     //                 <g transform={`rotate(${desks[selectedDeskIdx].rotation})`}>
    //     //                     <circle cx="0" cy="0" r="15" stroke="#b7b7b7" strokeDasharray="4" fill="none" />
    //     //                     <circle id="deskRotationHandle" cx="10" cy="-10" r="2" stroke="#999" strokeWidth="0.5" fill="white" />
    //     //                 </g>
    //     //             </svg>
    //     //         );
    //     //     }
    //     // }
    // }
    // return null;
};

export default MultiSelectCanvasControls;